export default import.meta.ROLLUP_FILE_URL_AsHNVVn_Y92mmWEtoBC9VA;